module.exports = __webpack_public_path__ + "static/media/tienda.8cfe32c5.svg";